import React, { useState } from 'react';
import { formatNumber } from './utils';
import ModalWrapper from './ModalWrapper';

export default function ConfirmBookingModal({ open, booking, onClose, onConfirm }) {
  const [qty, setQty] = useState(booking ? booking.quantity : '');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  // Reset qty when booking changes or modal opens
  React.useEffect(() => {
    setQty(booking ? booking.quantity : '');
  }, [booking, open]);

  if (!open || !booking) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    if (!qty || isNaN(qty) || Number(qty) <= 0) {
      setError('Quantity must be a positive number');
      setSubmitting(false);
      return;
    }
    await onConfirm(Number(qty));
    setSubmitting(false);
  };

  return (
    <ModalWrapper open={open} onClose={onClose} zIndex={100}>
      <h2 style={{color:'#1976d2',fontWeight:800,marginBottom:10,fontSize:22,letterSpacing:1}}>Confirm Booking</h2>
      <form onSubmit={handleSubmit} style={{width:'100%',display:'flex',flexDirection:'column',gap:18}}>
        <div style={{background:'#f1f8e9',padding:14,borderRadius:10,marginBottom:8}}>
          <div><b>Work Ticket Nr:</b> {booking.orderNumber}</div>
          <div><b>Customer:</b> {booking.clientName}</div>
          <div><b>Product Code:</b> {booking.productCode}</div>
          <div><b>Description:</b> {booking.mainCategory}</div>
          <div><b>Variant:</b> {booking.variantDesc}</div>
          <div><b>Label Size:</b> {booking.labelSize || '-'}</div>
          <div><b>Ordered Qty:</b> {formatNumber(booking.quantity)}</div>
        </div>
        <div style={{display:'flex', flexDirection:'column', gap:10}}>
          <label style={{fontWeight:500,marginBottom:2}}>Quantity</label>
          <input type="number" value={qty} onChange={e => setQty(e.target.value)} min="1" required style={{padding:10, borderRadius:6, border:'1px solid #bdbdbd'}} />
        </div>
        {error && <div style={{color:'red',marginBottom:8}}>{error}</div>}
        <div style={{display:'flex',gap:16,justifyContent:'center',marginTop:12}}>
          <button type="submit" disabled={submitting} style={{background:'#1976d2',color:'#fff',fontWeight:700,padding:'10px 32px',border:'none',borderRadius:8,boxShadow:'0 2px 8px #1976d233',fontSize:16}}>{submitting ? 'Confirming...' : 'Confirm'}</button>
          <button type="button" onClick={onClose} style={{background:'#fff',color:'#1976d2',fontWeight:700,padding:'10px 32px',border:'1.5px solid #1976d2',borderRadius:8,fontSize:16}}>Cancel</button>
        </div>
      </form>
    </ModalWrapper>
  );
}
